var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilesConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28655",
    "data-name": "Group 28655",
    transform: "translate(-1988 -3114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38012",
    "data-name": "Path 38012",
    d: "M628.079,472.079a28,28,0,1,0,28,28A28,28,0,0,0,628.079,472.079Z",
    transform: "translate(1387.921 2641.921)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-repeat",
    "data-name": "Icon feather-repeat",
    transform: "translate(2001.5 3128.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37926",
    "data-name": "Path 37926",
    d: "M25.5,1.5l4.364,4.364L25.5,10.227",
    transform: "translate(-5.727 0)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37927",
    "data-name": "Path 37927",
    d: "M4.5,14.045V11.864A4.364,4.364,0,0,1,8.864,7.5H24.136",
    transform: "translate(0 -1.636)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37928",
    "data-name": "Path 37928",
    d: "M8.864,31.227,4.5,26.864,8.864,22.5",
    transform: "translate(0 -5.727)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37929",
    "data-name": "Path 37929",
    d: "M24.136,19.5v2.182a4.364,4.364,0,0,1-4.364,4.364H4.5",
    transform: "translate(0 -4.909)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesConvert);
export default __webpack_public_path__ + "static/media/miles-convert.c2910d45c70d4f470295475a8e8ba34b.svg";
export { ForwardRef as ReactComponent };